import React from 'react';


const withPriceListLoader = (Component) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        price_lists: []
      }
    }

    componentDidMount = () => {
      this.loadPriceLists();
    }

    componentDidUpdate = (prevProps) => {
      if (prevProps.access_token !== this.props.access_token)
        this.loadPriceLists();
    }

    loadPriceLists = async () => {
      try{
        // Bsale pagina las respuestas (máximo 50 por página), por lo que
        // se recorren todas las páginas para no perder listas de precio
        const limit = 50;
        let offset = 0;
        let items = [];

        while (true) {
          const response = await fetch(
            `https://api.bsale.cl/v1/price_lists.json?state=0&limit=${limit}&offset=${offset}`,
            {
              method: "GET",
              cache: 'no-store',
              headers: {
                "access_token": this.props.access_token,
                "Content-Type": "application/json"
              }
            }
          );
          const json = await response.json();
          items = items.concat(json.items);
          offset += limit;

          if (json.items.length < limit || items.length >= json.count)
            break;
        }

        const price_lists = items.map(
          (item) => {
            return {
              id: item.id,
              name: item.name
            }
          }
        );

        this.setState({price_lists});
      }
      catch(error) {
        this.setState({price_lists: []});
      }
    }

    render = () => {
      return (
        <Component
          price_lists={this.state.price_lists}
          {...this.props}
          onTokenUpdate={this.loadPriceLists}
        ></Component>
      );
    }
  }
}

export default withPriceListLoader;
